import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';
import { FlashcardConfig } from '@lyceo/shared/flashcards/util-models';

export const FLASHCARD_CONFIG: InjectionToken<FlashcardConfig> =
  new InjectionToken<FlashcardConfig>('FLASHCARD_CONFIG');

export function provideFlashcard(
  config: FlashcardConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: FLASHCARD_CONFIG, useValue: config },
  ]);
}
